import React from 'react';
import './help.css';

function Help() {
  return (
    <div className="OCRP-help">
      {/* Tabs navigation */}
      <div className="OCRP-analysis-tabs">
        <button className="OCRP-tab-button OCRP-tab-active">
          <i className="fas fa-question-circle"></i>
          <span>Help & Support</span>
        </button>
      </div>
      
      <div className="OCRP-help-content">
        <div className="OCRP-help-header">
          <h1>OncoRisk Professional Help Center</h1>
          <p>Find guides, tutorials, and support resources for OncoRisk Professional</p>
        </div>
        
        <div className="OCRP-help-grid">
          <div className="OCRP-help-card">
            <div className="OCRP-help-icon">
              <i className="fas fa-book"></i>
            </div>
            <div className="OCRP-help-details">
              <h3>Documentation</h3>
              <p>Comprehensive guides and reference materials for OncoRisk Professional</p>
              <a href="https://www.phenomeportal.org/oncorisk/about" target="_blank" rel="noopener noreferrer" className="OCRP-help-link">
                <i className="fas fa-external-link-alt"></i>
                View Documentation
              </a>
            </div>
          </div>
          
          <div className="OCRP-help-card">
            <div className="OCRP-help-icon">
              <i className="fas fa-graduation-cap"></i>
            </div>
            <div className="OCRP-help-details">
              <h3>Tutorials</h3>
              <p>Step-by-step guides to help you get the most out of OncoRisk Professional</p>
              <a href="https://www.phenomeportal.org/oncorisk/about" target="_blank" rel="noopener noreferrer" className="OCRP-help-link">
                <i className="fas fa-external-link-alt"></i>
                View Tutorials
              </a>
            </div>
          </div>
          
          <div className="OCRP-help-card">
            <div className="OCRP-help-icon">
              <i className="fas fa-headset"></i>
            </div>
            <div className="OCRP-help-details">
              <h3>Technical Support</h3>
              <p>Get help from our support team for technical issues or questions</p>
              <a href="mailto:support@szapfs.org" className="OCRP-help-link">
                <i className="fas fa-envelope"></i>
                Contact Support
              </a>
            </div>
          </div>
          
          <div className="OCRP-help-card">
            <div className="OCRP-help-icon">
              <i className="fas fa-code-branch"></i>
            </div>
            <div className="OCRP-help-details">
              <h3>API Documentation</h3>
              <p>Technical documentation for integrating with OncoRisk Professional API</p>
              <a href="https://www.phenomeportal.org/oncorisk/about" target="_blank" rel="noopener noreferrer" className="OCRP-help-link">
                <i className="fas fa-external-link-alt"></i>
                View API Docs
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;
